import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import FirstAccess from "@/pages/FirstAccess";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import NovaFicha from "@/pages/NovaFicha";
import FichaDetail from "@/pages/FichaDetail";
import ClienteHistorico from "@/pages/ClienteHistorico";
import Vencimentos from "@/pages/Vencimentos";
import Profile from "@/pages/Profile";
import MaisVendidas from "@/pages/MaisVendidas";
import PublicClient from "@/pages/PublicClient";
import PublicCollector from "@/pages/PublicCollector";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Protected from "@/components/Protected";
import ErrorBoundary from "@/components/ErrorBoundary";
import KeyboardNav from "@/components/KeyboardNav";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <KeyboardNav />
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/primeiro-acesso" element={<FirstAccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/recuperar-senha" element={<ForgotPassword />} />
            <Route path="/painel" element={<Protected><Dashboard /></Protected>} />
            <Route path="/painel/nova-ficha" element={<Protected><NovaFicha /></Protected>} />
            <Route path="/painel/cliente/:key" element={<Protected><ClienteHistorico /></Protected>} />
            <Route path="/painel/ficha/:id" element={<Protected><FichaDetail /></Protected>} />
            <Route path="/painel/ficha/:id/editar" element={<Protected><NovaFicha /></Protected>} />
            <Route path="/painel/vencimentos" element={<Protected><Vencimentos /></Protected>} />
            <Route path="/painel/perfil" element={<Protected><Profile /></Protected>} />
            <Route path="/painel/mais-vendidas" element={<Protected><MaisVendidas /></Protected>} />
            <Route path="/c/:token" element={<PublicClient />} />
            <Route path="/cobranca/:token" element={<PublicCollector />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
